import { MESSAGE } from "@/constants/message";
import { STRONG_PASSWORD_REGEX } from "@/constants/regex";

import { ChangePasswordFormData } from "./types";

export const PASSWORD_FORM_RULES = {
  currentPassword: {
    required: true
  },
  newPassword: {
    required: true,
    pattern: {
      value: STRONG_PASSWORD_REGEX,
      message: "" // The error message validation will be on checklist.
    }
  },
  confirmNewPassword: {
    required: true,
    validate: (value: string, { newPassword }: ChangePasswordFormData) =>
      value === newPassword ||
      "Passwords  don't match. Please re-enter the same password."
  }
};

export const ERROR_DATA_MAPPING = {
  400: {
    title: MESSAGE.CHANGE_PASSWORD_INCORRECT_PASSWORD_TITLE,
    description: MESSAGE.CHANGE_PASSWORD_INCORRECT_PASSWORD_DESCRIPTION
  },
  500: {
    title: MESSAGE.CHANGE_PASSWORD_GENERAL_ERROR_TITLE,
    description: MESSAGE.CHANGE_PASSWORD_GENERAL_ERROR_DESCRIPTION
  }
};
